// extracted by mini-css-extract-plugin
export default {"container":"TermsOfServicePage_container__hW+r1","content":"TermsOfServicePage_content__NpjDa","backLink":"TermsOfServicePage_backLink__-0mVX"};